export default {"src":"/planos/_next/static/media/equifax-search-check.395d4f73.svg","height":19,"width":18,"blurWidth":0,"blurHeight":0};